module.exports = __webpack_public_path__ + "static/media/chart.752ef3ec.svg";